import {Link} from "react-router-dom";
import React, { useEffect, useState } from "react";
import TenantService from "../services/TenantService";

export default function Header() {
    const [tenantName, setTenantName] = useState("BookASeat");
    const [logoUrl, setLogoUrl] = useState(null);
    const [welcomeText, setWelcomeText] = useState("Välkommen att boka biljetter till en av våra resor. Du hittar alla våra resor och bokar samt betalar enkelt direkt på nätet.");
    const [tripsHeader, setTripsHeader] = useState("Våra resor");
    const [showTenantName, setShowTenantName] = useState(false);

    useEffect(() => {
        TenantService.getTenantInfo()
            .then(response => {
                if (response.data.tenant_name) {
                    setTenantName(response.data.tenant_name);
                }
                if (response.data.logo_url) {
                    setLogoUrl(response.data.logo_url);
                }
                if (response.data.welcome_text) {
                    setWelcomeText(response.data.welcome_text);
                }
                if (response.data.trips_header) {
                    setTripsHeader(response.data.trips_header);
                }
                if (response.data.show_tenant_name) {
                    setShowTenantName(true);
                }
            })
            .catch(e => {
                console.error("Failed to fetch tenant info:", e);
            });
    }, []);

    return (
        <div className="bg-white">
            <div className="max-w-7xl mx-auto pt-4 px-4 sm:px-6 lg:px-8 flex justify-end">
                <Link to="/mina-bokningar" className="text-sm font-medium text-indigo-600 hover:text-indigo-500">
                    Mina bokningar
                </Link>
            </div>
            <div className="max-w-7xl mx-auto py-16 px-4 sm:py-24 sm:px-6 lg:px-8">
                <div className="text-center">
                    {logoUrl && (
                        <div className="flex justify-center mb-6">
                            <img src={logoUrl} alt={tenantName} className="h-24 w-auto max-w-full object-contain" />
                        </div>
                    )}
                    {showTenantName && <h2 className="text-base font-semibold text-indigo-600 tracking-wide uppercase">{tenantName}</h2>}
                    <p className="mt-1 text-4xl font-extrabold text-gray-900 sm:text-5xl sm:tracking-tight lg:text-6xl">
                        <Link to={"/"}>
                            {tripsHeader}
                        </Link>
                    </p>
                    <p className="max-w-xl mt-5 mx-auto text-xl text-gray-500">
                        {welcomeText}
                    </p>
                </div>
            </div>
        </div>
    )
}
